export default "__VITE_ASSET__CUVgClsw__"